import { ActionBase } from './action-base';
import { type } from '../../shared/components/helpers/util';

import * as models from '../../shared/models';

/**
 * For each action type in an action group, make a simple
 * enum object for all of this group's action types.
 *
 * The 'type' utility function coerces strings into string
 * literal types and runs a simple check to guarantee all
 * action types in the application are unique.
 */

/**
 * Following action types are being used for the Auth Data
 */
export const actionTypes = {
    SET_SHARED_DATA : type('[Shared Data] set shared data action'),
    GET_SHARED_DATA : type('[Shared Data] get shared data action'),
};

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions:
 * https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */

/**
 * Class used to set the Shared Data object
 */
export class SetSharedDataAction implements ActionBase {
  type = actionTypes.SET_SHARED_DATA;

  constructor(public payload: models.SharedData) { }
}
/**
 * Class used to get the Shared Data object
 */
export class GetSharedDataAction implements ActionBase {
  type = actionTypes.GET_SHARED_DATA;

  constructor() { }
}



/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type actions
= SetSharedDataAction
| GetSharedDataAction;

